import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area'
import * as React from 'react'

import { cn } from '#lib/utils'

function ScrollArea({
	className,
	children,
	viewportRef,
	orientation = 'vertical',
	...props
}: ScrollAreaPrimitive.Root.Props & {
	viewportRef?: React.Ref<HTMLDivElement>
	orientation?: 'vertical' | 'horizontal'
}) {
	return (
		<ScrollAreaPrimitive.Root
			className={cn('relative', className)}
			data-slot='scroll-area'
			{...props}
		>
			<ScrollAreaPrimitive.Viewport
				className='size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1'
				data-slot='scroll-area-viewport'
				ref={viewportRef}
			>
				{children}
			</ScrollAreaPrimitive.Viewport>
			<ScrollBar orientation={orientation} />
			<ScrollAreaPrimitive.Corner />
		</ScrollAreaPrimitive.Root>
	)
}

function ScrollBar({
	className,
	orientation = 'vertical',
	...props
}: ScrollAreaPrimitive.Scrollbar.Props) {
	return (
		<ScrollAreaPrimitive.Scrollbar
			className={cn(
				'flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent',
				className
			)}
			data-orientation={orientation}
			data-slot='scroll-area-scrollbar'
			orientation={orientation}
			{...props}
		>
			<ScrollAreaPrimitive.Thumb
				className='relative flex-1 rounded-full bg-border'
				data-slot='scroll-area-thumb'
			/>
		</ScrollAreaPrimitive.Scrollbar>
	)
}

export { ScrollArea, ScrollBar }
